import i18n from 'i18next';

import enMessages from './app/en.messages.json';
import frMessages from './app/fr.messages.json';

import dictionaryEnglish from './translate/en.resources';
import dictionaryFrench from './translate/fr.resources';

const supportedLanguages = ['en', 'fr'];
export const defaultLanguage = 'en';

export const normalizeLanguage = (lang) => {
    const baseLang = !!lang ? lang.toLowerCase().split('-')[0] : defaultLanguage;

    return supportedLanguages.includes(baseLang || '') ? baseLang : undefined;
};

const getBrowserLanguage = () => {
    if (typeof navigator === 'undefined') {
        return defaultLanguage;
    }

    const browserLanguages = navigator.languages?.length
        ? navigator.languages
        : [navigator.language];

    const firstSupportedLanguage = browserLanguages
        .map(normalizeLanguage)
        .find(Boolean);

    return firstSupportedLanguage || defaultLanguage;
};

const initialLanguage = getBrowserLanguage();

export const getAppText = (key, options) => {
    return i18n.t(key, { ns: 'app', ...options });
};

i18n.init({
    lng: initialLanguage,
    fallbackLng: defaultLanguage,
    resources: {
        en: {
            app: enMessages,
            translate: dictionaryEnglish
        },
        fr: {
            app: frMessages,
            translate: dictionaryFrench
        },
    },

    debug: false,
    ns: ['app', 'translate'],
    defaultNS: 'translate',
    supportedLngs: ['fr', 'en'],
    load: 'languageOnly',
    interpolation: {
        escapeValue: false,
    },
    react: {
        useSuspense: true,
    },
});

export default i18n;

